export class TutorialTooltip {
  titleResourceKey: string;
  descriptionResourceKey: string;
  arialabelResourceKey: string;
  lockScrollbar: boolean;

  constructor(sequenceId: string, step: number, show = false, lockScrollbar = false) {
    this.titleResourceKey = `Tutorial.${sequenceId}.Step${step}.Title`;
    this.descriptionResourceKey = `Tutorial.${sequenceId}.Step${step}.Description`;
    this.arialabelResourceKey = `Tutorial.${sequenceId}.Step${step}.Arialabel`;
    this.lockScrollbar = lockScrollbar;
  }
}
